import { cx } from '@emotion/css'
import { Box } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import Typography from '../../atoms/typography'
import Button from '../button'
import { getCustomOptionComponent } from './types'

const CustomOptionsUI = ({ customOptions, resetCustomOptions }) => {
	return (
		<>
			{!!customOptions && customOptions?.length > 0 && (
				<Box className={cx('CustomOptions-root')} mt={2}>
					<Typography variant="h3" mb={2}>
						<FormattedMessage id="custom_options_title" />
					</Typography>
					{resetCustomOptions && (
						<Button onClick={resetCustomOptions} size="small">
							<FormattedMessage id="reset" />
						</Button>
					)}
					<Box className={cx('CustomOptions-fields')} mt={2}>
						{customOptions.map(({ id, ...customOption }) => {
							const CustomOptionComponent = getCustomOptionComponent(customOption)
							return <CustomOptionComponent key={id} id={id} {...customOption} />
						})}
					</Box>
				</Box>
			)}
		</>
	)
}

export default CustomOptionsUI
